const inputValidationRules = {
	required: {
		text: {
			invalid: 'Поле обязательно для заполнения',
			valid: ''
		},
		validate(field) {
			if(!field.value || (field.value.length < 1 || field.value.length > 255)) {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	social: {
		text: {
			invalid: 'Введена невалидная ссылка на соцсеть',
			valid: ''
		},
		validate(field) {
			if((field.value && !field.value.startsWith(`https://${field.socialType}.com`)) &&
                (field.value && !field.value.startsWith(`https://www.${field.socialType}.com`))) {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	website: {
		text: {
			invalid: 'Введите корректный адрес сайта',
			valid: ''
		},
		validate(field) {
			if((field.value.search(/^((https?|ftp)\:\/\/)?([a-z0-9]{1})((\.[a-z0-9-])|([a-z0-9-]))*\.([a-z]{2,4})$/) === -1) ||
                (!field.value.startsWith('https://') && !field.value.startsWith('http://'))) {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	lastName: {
		text: {
			invalid: 'Фамилия должна содержать от 1 до 255 символов',
			valid: ''
		},
		validate(field) {
			return inputValidationRules.minMaxSymbol(this.text, field.value);
		}
	},
	file: {
		text: {
			invalid: 'Необходимо загрузить файл',
			valid: ''
		},
		validate (field) {
			if(!field.value) {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	name: {
		text: {
			invalid: 'Имя должно содержать от 1 до 255 символов',
			valid: ''
		},
		validate(field) {
			return inputValidationRules.minMaxSymbol(this.text, field.value);
		}
	},
	requiredAddress: {
		text: {
			invalid: 'Необходимо указать адрес',
			valid: ''
		},
		validate (field) {
			return inputValidationRules.minMaxSymbol(this.text, field.value);
		}
	},
	requiredCity: {
		text: {
			invalid: 'Необходимо указать город',
			valid: ''
		},
		validate (field) {
			return inputValidationRules.minMaxSymbol(this.text, field.value);
		}
	},
	coords: {
		text: {
			invalid: 'Необходимо задать координаты',
			invalidCoords: 'Необходимо задать широту и долготу через запятую',
			invalidLat: 'Широта должна быть в диапазоне от -90° до 90°',
			invalidLong: 'Долгота должна быть в диапазоне от 0° до 180°',
			invalidCordValue: 'Не больше 6-ти знаков после запятой',
			valid: ''
		},
		validateCoord(coord, validCondition, text) {
			const coordValue = coord.replace(',', '.');

			if (validCondition(coordValue)) {
				return text;
			}

			const coordAfterDecimalValue = coordValue.split('.')[1];

			if (coordAfterDecimalValue && coordAfterDecimalValue.length > 6) {
				return this.text.invalidCordValue;
			}
		},
		validate(field) {
			if(field.value) {
				let coordsArray = field.value.split(',', 2);
				if(coordsArray.length !== 2) {
					return this.text.invalidCoords;
				}

				const validationLat = (coord) => !coord.length || (coord < -90 || coord > 90);
				const validationLong = (coord) => !coord.length || (coord < 0 || coord > 180);

				const validateLat = this.validateCoord(coordsArray[0], validationLat, this.text.invalidLat);
				const validateLong = this.validateCoord(coordsArray[1], validationLong, this.text.invalidLong);

				if (validateLat) return validateLat;
				if (validateLong) return validateLong;

			} else {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	requiredLong: {
		text: {
			invalid: 'Поле обязательно для заполнения',
			valid: ''
		},
		validate(field) {
			if (!field.value.length){
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	postal: {
		text: {
			invalid: 'Индекс должен содержать 6 цифр',
			valid: ''
		},
		validate(field) {
			if (field.value.length !== 6){
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	email: {
		text: {
			invalid: 'Введите корректный e-mail',
			valid: ''
		},
		validate(field) {
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(field.value).toLowerCase())){
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	phone: {
		text: {
			invalid: 'Введите корректный номер телефона',
			valid: ''
		},
		validate(field) {
			const re = /^((\+7|7|8)+([0-9]){10})$/;
			if (!re.test(String(field.value).toLowerCase())){
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	validYear: {
		text: {
			invalid: 'Поле не может быть пустым',
			invalidYear: (minYear, currentYear) => `Год не может быть меньше ${minYear} и больше текущего`,
			valid: ''
		},
		validate(field) {
			if (field.value) {
				const currentDate = new Date();
				const currentYear = currentDate.getFullYear();
				if(+field.value < field.minYear || +field.value > currentYear) {
					return this.text.invalidYear(field.minYear, currentYear);
				}
			}else {
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	date: {
		text: {
			invalidDate: 'Введите корректный возраст',
			valid: ''
		},
		validate(field) {
			if(field.value.length) {
				let today = new Date();
				let dd = today.getDate();
				let mm = today.getMonth()+1;
				let yyyy = today.getFullYear();
				if(dd<10){
					dd='0'+dd;
				}
				if(mm<10){
					mm='0'+mm;
				}
				const min = (yyyy-18)+'-'+mm+'-'+dd;
				const max = (yyyy-80)+'-'+mm+'-'+dd;
				if(field.value < max || field.value > min) {
					return this.text.invalidDate;
				}
			}

			return this.text.valid;
		}
	},
	agreement: {
		text: {
			invalid: 'Необходимо дать согласие на обработку персональных данных',
			valid: ''
		},
		validate(field) {
			if (!field.value){
				return this.text.invalid;
			}

			return this.text.valid;
		}
	},
	password: {
		text: {
			invalidMin: 'Пароль ненадёжный, используйте от 6 символов',
			invalidMax: 'Пароль должен быть не длиннее 50 символов',
			valid: ''
		},
		validate(field) {
			if(field.value.length < 6) {
				return this.text.invalidMin;
			}
			if(field.value.length > 50) {
				return this.text.invalidMax;
			}

			return this.text.valid;
		}
	},

	minMaxSymbol(text, value) {
		if(value.length < 1 || value.length > 255) {
			return text.invalid;
		}

		return text.valid;
	}

};



export { inputValidationRules };
